import React from "react";

const UserRolesManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.451"
      height="38.895"
      viewBox="0 0 44.451 38.895"
    >
      <path
        id="db60"
        d="M257.036,237.877a5.556,5.556,0,1,1-4.813,8.335H240.366v26.856a.926.926,0,0,1-.926.926H228.51a5.556,5.556,0,1,1,0-5.557h6.3V241.58a.926.926,0,0,1,.926-.926h16.487a5.554,5.554,0,0,1,4.813-2.778Zm0,27.781a5.556,5.556,0,1,1-5.557,5.556A5.557,5.557,0,0,1,257.036,265.658ZM223.7,268.436a2.778,2.778,0,1,0,2.778,2.778A2.778,2.778,0,0,0,223.7,268.436Zm33.338,0a2.778,2.778,0,1,0,2.778,2.778A2.779,2.779,0,0,0,257.036,268.436Zm-9.261,0a.926.926,0,0,1,.926.926v3.7a.926.926,0,0,1-.926.926h-3.7a.926.926,0,0,1-.926-.926v-3.7a.926.926,0,0,1,.926-.926Zm9.261-27.781a2.778,2.778,0,1,0,2.778,2.778A2.779,2.779,0,0,0,257.036,240.654Z"
        transform="translate(-218.141 -237.876)"
        fill={fill ? fill : "#ff7eb5"}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default UserRolesManagementIcon;
